import { useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import { useAuthContext } from "../../../hooks/useAuthContext";
import MeaPageTitle from "../../../components/MeaPageTitle";
import { useRef, useState } from "react";
import SessionDetailComponent from "./components/SessionDetailComponent";
import sessionsAPI from "../../../services/sessions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { TabMenu } from "primereact/tabmenu";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import AttendancesListComponent from "../../trainings/attendances/components/AttendancesListComponent";
import { PERMISSION_TRAINING_ATTANDANCES, PERMISSION_TRAINING_SESSIONS } from "../../../permissions";
import MeaPageHeader from "../../../components/MeaPageHeader";
import { ToFormatedDateWithWeekday } from "../../../utils/dates";
import MeaPermissionGuard from "../../../components/MeaPermissionGuard";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";

const PresencesSessionDetailPageContent = ({ schoolId, trainingId }) => {
  const { hasPermission } = useAuthContext();
  //
  const params = useParams();
  const accessToken = "";
  //
  const updateModalRef = useRef();

  const toast = useRef();
  const navigate = useNavigate();
  const sessionId = params.sessionId;
  //
  const sessionQuery = sessionsAPI.GetOne(
    schoolId,
    trainingId,
    accessToken,
    sessionId
  );
  const sessionObj = sessionQuery?.data?.data;
  //
  const [activeTab, setActiveTab] = useState(0);
  var tabs = [{ label: "Feuille de présence", key: "attendances", icon: "pi pi-th-large", disable: !hasPermission(PERMISSION_TRAINING_ATTANDANCES.LIST) }];
  tabs = tabs.filter(item => !item.disable);
  //
  return (
    <>
      <MeaPage
        showBackButton={true}
        breadcrumb={
          <SecretariatWorkspaceBar
            section="presences"
            trailing={
              sessionObj?.event?.start_date
                ? `Séance du ${ToFormatedDateWithWeekday(new Date(sessionObj.event.start_date))}`
                : "Séance"
            }
          />
        }
        title={
          <MeaPageTitle
            prefix={"Séance de cours: "}
            title={ToFormatedDateWithWeekday(
              new Date(sessionObj?.event?.start_date)
            )}
          />
        }
        actions={[
          {
            label: "Modifier",
            icon: "pi pi-file-edit",
            disable: !hasPermission(PERMISSION_TRAINING_SESSIONS.UPDATE),
            command: () => {
              if (updateModalRef.current) {
                updateModalRef.current.show(() => {
                  sessionQuery.refetch();
                });
              }
            },
          },
          {
            separator: true,
            disable: !hasPermission(PERMISSION_TRAINING_SESSIONS.DELETE),
          },
          {
            label: "Supprimer",
            icon: "pi pi-trash",
            disable: !hasPermission(PERMISSION_TRAINING_SESSIONS.DELETE),
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment supprimer cette session?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                defaultFocus: "reject",
                acceptClassName: "p-button-danger",
                accept: () => {
                  sessionsAPI
                    .DeleteOne(schoolId, trainingId, accessToken, sessionId)
                    .then((data) => {
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: sessionObj?.name + " Supprimé!",
                        life: 3000,
                      });
                      navigate(
                        "/school/" + schoolId + "/admin/trainings/" + trainingId + "/sessions"
                      );
                    })
                    .catch((error) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de suppression!",
                      });
                    });
                },
              });
            },
          },
        ]}
      >
        <MeaPageHeader>
          <SessionDetailComponent session={sessionObj} callback={() => {
            sessionQuery.refetch();
          }} />
        </MeaPageHeader>

        {/* <UpdateSessionModal ref={updateModalRef} session={sessionObj} accessToken={accessToken} schoolId={schoolId} trainingId={trainingId} /> */}

        <ConfirmDialog />
        <Toast ref={toast} />

        <div className="mt-5">
          {tabs.length > 0 && <TabMenu
            model={tabs}
            activeIndex={activeTab}
            onTabChange={(e) => {
              setActiveTab(e.index);
            }}
          />
          }
          {tabs[activeTab]?.key === "attendances" && (
            <MeaLoadingContent objectQuery={sessionQuery}>
              <AttendancesListComponent
                schoolId={schoolId}
                trainingId={trainingId}
                session={sessionObj}
                showAddButton={true}
                showFilterButton={false}
                showToolbar={true}
              />
            </MeaLoadingContent>
          )}
        </div>
      </MeaPage>
    </>
  );
};

const PresencesSessionDetailPage = () => {
  const { schoolId, trainingId } = useParams();

  return (
    <MeaPermissionGuard
      permission={PERMISSION_TRAINING_SESSIONS.GET}
      fallbackTo={`/school/${schoolId}/secretariat/presences/${trainingId}`}
    >
      <PresencesSessionDetailPageContent schoolId={schoolId} trainingId={trainingId} />
    </MeaPermissionGuard>
  );
};

export default PresencesSessionDetailPage;
